(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[80594,72198,90570,36013,75171,27786,57917,16571,39239,95312,78671,89683,2611,14641,53449,85688],{

/***/ 72198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addressStep": function() { return /* binding */ addressStep; }
/* harmony export */ });
/* harmony import */ var _domain_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32279);

var addressStep = {
    type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestStepType.DETAILS */ .ln.DETAILS,
    inSummary: true,
    title: "quote:address.title",
    segmentEvent: "Additional Info Filled in",
    fields: [
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.ADDRESS */ .lZ.ADDRESS,
            summaryTitle: "quote:address.summaryTitle",
            props: {
                name: "full_address",
                placeholder: "quote:selfQualif.steps.location.street.summaryTitle",
                validation: [
                    "isRequired"
                ]
            }
        },
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.CHECKBOX */ .lZ.CHECKBOX,
            summaryTitle: "quote:address.nested_summaryTitle",
            props: {
                name: "common_building",
                placeholder: "quote:address.common_building"
            }
        }, 
    ]
};


/***/ }),

/***/ 90570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ageOfBuildingStep": function() { return /* binding */ ageOfBuildingStep; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);
/* harmony import */ var _domain_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32279);
/* harmony import */ var _brand_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36499);



var ageOfBuildingStep = {
    type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestStepType.DETAILS */ .ln.DETAILS,
    inSummary: true,
    title: "quote:ageOfBuilding.title",
    subTitle: "quote:ageOfBuilding.subTitle",
    segmentEvent: "Additional Info Filled in",
    fields: [
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.TILES */ .lZ.TILES,
            summaryTitle: "quote:ageOfBuilding.summaryTitle",
            props: {
                name: "age_of_building",
                options: [
                    {
                        label: "quote:ageOfBuilding.options.less_than_10",
                        value: "younger_than_10_years",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_brand_icons__WEBPACK_IMPORTED_MODULE_1__/* .TimeClock */ .qA, {})
                    },
                    {
                        label: "quote:ageOfBuilding.options.more_than_10",
                        value: "older_than_10_years",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_brand_icons__WEBPACK_IMPORTED_MODULE_1__/* .TimeClock */ .qA, {})
                    }, 
                ],
                validation: [
                    "isRequired"
                ]
            }
        }, 
    ]
};


/***/ }),

/***/ 36013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "budgetStep": function() { return /* binding */ budgetStep; }
/* harmony export */ });
/* harmony import */ var _domain_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32279);

var budgetStep = {
    type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestStepType.DETAILS */ .ln.DETAILS,
    inSummary: true,
    title: "quote:budget.title",
    subTitle: "quote:budget.subtitle",
    additionalCopy: "quote:additionalCopy.description.title",
    segmentEvent: "Additional Info Filled in",
    fields: [
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.SELECT */ .lZ.SELECT,
            summaryTitle: "quote:budget.summaryTitle",
            props: {
                name: "budget",
                options: [
                    {
                        label: "0 - 200€",
                        value: "0_200"
                    },
                    {
                        label: "200 - 500€",
                        value: "200_500"
                    },
                    {
                        label: "500 - 1000€",
                        value: "500_1000"
                    },
                    {
                        label: "1000 - 1500€",
                        value: "1000_1500"
                    },
                    {
                        label: "1500 - 2000€",
                        value: "1500_2000"
                    },
                    {
                        label: "2000 - 3000€",
                        value: "2000_3000"
                    },
                    {
                        label: "3000€ - 5000€",
                        value: "3000_5000"
                    },
                    {
                        label: "5000€ - 10 000€",
                        value: "5000_10000"
                    },
                    {
                        label: "10 000€ - 25 000€",
                        value: "10000_25000"
                    },
                    {
                        label: "> 30 000€",
                        value: "+30000"
                    }, 
                ],
                validation: [
                    "isRequired"
                ]
            }
        }, 
    ]
};


/***/ }),

/***/ 75171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "contactStep": function() { return /* binding */ contactStep; }
/* harmony export */ });
/* harmony import */ var _domain_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32279);

var contactStep = {
    type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestStepType.CONTACT */ .ln.CONTACT,
    inSummary: true,
    title: "quote:contact.title",
    additionalCopy: "quote:contact.title",
    segmentEvent: "Contact Filled in",
    fields: [
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.INPUT */ .lZ.INPUT,
            summaryTitle: "form:placeholder.firstName",
            props: {
                name: "project.user.first_name",
                label: "quote:contact.firstName.label",
                type: "text",
                // placeholder: `form:placeholder.firstName`,
                regex: "/^([^0-9]*)$/",
                validation: [
                    "isRequired"
                ]
            }
        },
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.INPUT */ .lZ.INPUT,
            summaryTitle: "form:placeholder.lastName",
            props: {
                name: "project.user.last_name",
                label: "quote:contact.lastName.label",
                type: "text",
                // placeholder: `form:placeholder.lastName`,
                regex: "/^([^0-9]*)$/",
                validation: [
                    "isRequired"
                ]
            }
        },
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.INPUT */ .lZ.INPUT,
            summaryTitle: "form:placeholder.phone",
            props: {
                name: "project.user.phone",
                type: "text",
                // placeholder: `quote:phone.phone.placeholder`,
                label: "quote:contact.phone.label",
                validation: [
                    "isRequired"
                ]
            }
        },
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.INPUT */ .lZ.INPUT,
            summaryTitle: "form:placeholder.email",
            props: {
                name: "project.user.email",
                // placeholder: `form:placeholder.email`,
                label: "quote:contact.email.label",
                type: "email",
                validation: [
                    "isRequired",
                    "isEmail"
                ]
            }
        }, 
    ]
};


/***/ }),

/***/ 27786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "descriptionStep": function() { return /* binding */ descriptionStep; }
/* harmony export */ });
/* harmony import */ var _domain_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32279);
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(475);


//descriptionStep that is required
var descriptionStep = {
    type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestStepType.DETAILS */ .ln.DETAILS,
    inSummary: true,
    title: "quote:description.title",
    additionalCopy: "quote:additionalCopy.description.title",
    segmentEvent: "Additional Info Filled in",
    fields: [
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.TEXTAREA */ .lZ.TEXTAREA,
            summaryTitle: "quote:description.summaryTitle",
            props: {
                name: "questions.".concat((0,i18next__WEBPACK_IMPORTED_MODULE_1__.t)("quote:description.summaryTitle")),
                placeholder: "quote:description.placeholder",
                validation: [
                    "isRequired",
                    "minLength(10)"
                ]
            }
        }, 
    ]
};


/***/ }),

/***/ 57917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "descriptionStepNotRequired": function() { return /* binding */ descriptionStepNotRequired; }
/* harmony export */ });
/* harmony import */ var _domain_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32279);
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(475);


//descriptionStep that is not required
//step 3 RFQ and IR
var descriptionStepNotRequired = {
    type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestStepType.DETAILS */ .ln.DETAILS,
    inSummary: true,
    title: "quote:descriptionNotRequired.title",
    additionalCopy: "quote:additionalCopy.description.title",
    segmentEvent: "Additional Info Filled in",
    fields: [
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.TEXTAREA */ .lZ.TEXTAREA,
            summaryTitle: "quote:descriptionNotRequired.summaryTitle",
            props: {
                name: "questions.".concat((0,i18next__WEBPACK_IMPORTED_MODULE_1__.t)("quote:descriptionNotRequired.summaryTitle")),
                placeholder: "quote:descriptionNotRequired.placeholder"
            }
        }, 
    ]
};


/***/ }),

/***/ 16571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "emailStep": function() { return /* binding */ emailStep; }
/* harmony export */ });
/* harmony import */ var _domain_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32279);

var emailStep = {
    type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestStepType.CONTACT */ .ln.CONTACT,
    inSummary: true,
    title: "quote:email.title",
    additionalCopy: "quote:additionalCopy.email.title",
    segmentEvent: "Email Address Filled in",
    fields: [
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.INPUT */ .lZ.INPUT,
            summaryTitle: "form:placeholder.email",
            props: {
                name: "project.user.email",
                placeholder: "form:placeholder.email",
                type: "email",
                validation: [
                    "isRequired",
                    "isEmail"
                ]
            }
        }, 
    ]
};


/***/ }),

/***/ 80594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addressStep": function() { return /* reexport safe */ _addressStep__WEBPACK_IMPORTED_MODULE_0__.addressStep; },
/* harmony export */   "ageOfBuildingStep": function() { return /* reexport safe */ _ageOfBuildingStep__WEBPACK_IMPORTED_MODULE_1__.ageOfBuildingStep; },
/* harmony export */   "budgetStep": function() { return /* reexport safe */ _budgetStep__WEBPACK_IMPORTED_MODULE_2__.budgetStep; },
/* harmony export */   "contactStep": function() { return /* reexport safe */ _contactStep__WEBPACK_IMPORTED_MODULE_5__.contactStep; },
/* harmony export */   "descriptionStep": function() { return /* reexport safe */ _descriptionStep__WEBPACK_IMPORTED_MODULE_3__.descriptionStep; },
/* harmony export */   "descriptionStepNotRequired": function() { return /* reexport safe */ _descriptionStepNotRequired__WEBPACK_IMPORTED_MODULE_4__.descriptionStepNotRequired; },
/* harmony export */   "emailStep": function() { return /* reexport safe */ _emailStep__WEBPACK_IMPORTED_MODULE_6__.emailStep; },
/* harmony export */   "jobDateStep": function() { return /* reexport safe */ _jobDateStep__WEBPACK_IMPORTED_MODULE_7__.jobDateStep; },
/* harmony export */   "jobTypeStep": function() { return /* reexport safe */ _jobTypeStep__WEBPACK_IMPORTED_MODULE_8__.jobTypeStep; },
/* harmony export */   "materialsStep": function() { return /* reexport safe */ _materialsStep__WEBPACK_IMPORTED_MODULE_9__.materialsStep; },
/* harmony export */   "nameStep": function() { return /* reexport safe */ _nameStep__WEBPACK_IMPORTED_MODULE_10__.nameStep; },
/* harmony export */   "phoneStep": function() { return /* reexport safe */ _phoneStep__WEBPACK_IMPORTED_MODULE_11__.phoneStep; },
/* harmony export */   "typeOfInterventionStep": function() { return /* reexport safe */ _typeOfInterventionStep__WEBPACK_IMPORTED_MODULE_12__.typeOfInterventionStep; },
/* harmony export */   "uploadStep": function() { return /* reexport safe */ _uploadStep__WEBPACK_IMPORTED_MODULE_13__.uploadStep; },
/* harmony export */   "zipStep": function() { return /* reexport safe */ _zipStep__WEBPACK_IMPORTED_MODULE_14__.zipStep; }
/* harmony export */ });
/* harmony import */ var _addressStep__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72198);
/* harmony import */ var _ageOfBuildingStep__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90570);
/* harmony import */ var _budgetStep__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36013);
/* harmony import */ var _descriptionStep__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27786);
/* harmony import */ var _descriptionStepNotRequired__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57917);
/* harmony import */ var _contactStep__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75171);
/* harmony import */ var _emailStep__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16571);
/* harmony import */ var _jobDateStep__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39239);
/* harmony import */ var _jobTypeStep__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95312);
/* harmony import */ var _materialsStep__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78671);
/* harmony import */ var _nameStep__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89683);
/* harmony import */ var _phoneStep__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2611);
/* harmony import */ var _typeOfInterventionStep__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14641);
/* harmony import */ var _uploadStep__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(53449);
/* harmony import */ var _zipStep__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85688);

















/***/ }),

/***/ 39239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jobDateStep": function() { return /* binding */ jobDateStep; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);
/* harmony import */ var _domain_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32279);
/* harmony import */ var _brand_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36499);



var jobDateStep = {
    type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestStepType.DETAILS */ .ln.DETAILS,
    inSummary: true,
    title: "quote:jobDate.title",
    segmentEvent: "Time of Execution Selected",
    fields: [
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.TILES */ .lZ.TILES,
            summaryTitle: "quote:jobDate.summaryTitle",
            props: {
                name: "job_date",
                options: [
                    {
                        label: "quote:jobDate.options.asap",
                        value: "within_2_weeks",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_brand_icons__WEBPACK_IMPORTED_MODULE_1__/* .TimeClock */ .qA, {})
                    },
                    {
                        label: "quote:jobDate.options.nextFewWeeks",
                        value: "this_month",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_brand_icons__WEBPACK_IMPORTED_MODULE_1__/* .CalendarDay */ .X5, {})
                    },
                    {
                        label: "quote:jobDate.options.nextFewMonths",
                        value: "within_2_months",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_brand_icons__WEBPACK_IMPORTED_MODULE_1__/* .CalendarMonth */ .CH, {})
                    },
                    {
                        label: "quote:jobDate.options.flexible",
                        value: "flexible",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_brand_icons__WEBPACK_IMPORTED_MODULE_1__/* .NoDeadline */ .Yt, {})
                    }, 
                ],
                validation: [
                    "isRequired"
                ]
            }
        }, 
    ]
};


/***/ }),

/***/ 95312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jobTypeStep": function() { return /* binding */ jobTypeStep; }
/* harmony export */ });
/* harmony import */ var _domain_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32279);

var jobTypeStep = function(categories) {
    return {
        type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestStepType.DETAILS */ .ln.DETAILS,
        inSummary: true,
        title: "quote:jobType.title",
        additionalCopy: "quote:additionalCopy.jobType.title",
        segmentEvent: "Job Type Selected",
        fields: [
            {
                type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.TILES */ .lZ.TILES,
                summaryTitle: "quote:jobType.summaryTitle",
                props: {
                    name: "category_id",
                    options: categories,
                    validation: [
                        "isRequired"
                    ]
                }
            }, 
        ]
    };
};


/***/ }),

/***/ 78671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "materialsStep": function() { return /* binding */ materialsStep; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52903);
/* harmony import */ var _domain_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32279);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_Check_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3558);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_Check_svg__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_hoa_svg_ServiceRequst_SelfQualif_Check_svg__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_Star_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29013);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_Star_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_hoa_svg_ServiceRequst_SelfQualif_Star_svg__WEBPACK_IMPORTED_MODULE_2__);




var materialsStep = {
    type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestStepType.DETAILS */ .ln.DETAILS,
    inSummary: true,
    title: "quote:selfQualif.steps.materials.title",
    segmentEvent: "Additional Info Filled in",
    fields: [
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.TILES */ .lZ.TILES,
            summaryTitle: "quote:selfQualif.steps.materials.summaryTitle",
            props: {
                name: "providing_materials",
                options: [
                    {
                        label: "common:generic.yes",
                        value: "true",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((_hoa_svg_ServiceRequst_SelfQualif_Check_svg__WEBPACK_IMPORTED_MODULE_1___default()), {})
                    },
                    {
                        label: "common:generic.no",
                        value: "false",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((_hoa_svg_ServiceRequst_SelfQualif_Star_svg__WEBPACK_IMPORTED_MODULE_2___default()), {}),
                        default: true
                    }, 
                ],
                validation: [
                    "isRequired"
                ]
            }
        }, 
    ]
};


/***/ }),

/***/ 89683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nameStep": function() { return /* binding */ nameStep; }
/* harmony export */ });
/* harmony import */ var _domain_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32279);

var nameStep = {
    type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestStepType.CONTACT */ .ln.CONTACT,
    inSummary: true,
    title: "quote:name.title",
    additionalCopy: "quote:additionalCopy.name.title",
    segmentEvent: "Name Filled in",
    fields: [
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.INPUT */ .lZ.INPUT,
            summaryTitle: "form:placeholder.firstName",
            props: {
                name: "project.user.first_name",
                placeholder: "form:placeholder.firstName",
                validation: [
                    "isRequired"
                ]
            }
        },
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.INPUT */ .lZ.INPUT,
            summaryTitle: "form:placeholder.lastName",
            props: {
                name: "project.user.last_name",
                placeholder: "form:placeholder.lastName",
                validation: [
                    "isRequired"
                ]
            }
        }, 
    ]
};


/***/ }),

/***/ 2611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "phoneStep": function() { return /* binding */ phoneStep; }
/* harmony export */ });
/* harmony import */ var _domain_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32279);

var phoneStep = {
    type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestStepType.CONTACT */ .ln.CONTACT,
    inSummary: true,
    title: "quote:phone.title",
    additionalCopy: "quote:additionalCopy.phone.title",
    segmentEvent: "Phone Number Filled in ",
    fields: [
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.INPUT */ .lZ.INPUT,
            summaryTitle: "form:placeholder.phone",
            props: {
                name: "project.user.phone",
                placeholder: "quote:phone.phone.placeholder",
                validation: [
                    "isRequired"
                ]
            }
        },
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.TEXTAREA */ .lZ.TEXTAREA,
            summaryTitle: "quote:phone.comment.summaryTitle",
            props: {
                name: "project.user.phone_comment",
                placeholder: "quote:phone.comment.placeholder"
            }
        }, 
    ]
};


/***/ }),

/***/ 14641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "typeOfInterventionStep": function() { return /* binding */ typeOfInterventionStep; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52903);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_Compliance_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48255);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_Compliance_svg__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_hoa_svg_ServiceRequst_SelfQualif_Compliance_svg__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_ElectricalInstallation_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87432);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_ElectricalInstallation_svg__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_hoa_svg_ServiceRequst_SelfQualif_ElectricalInstallation_svg__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_Repair_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64698);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_Repair_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_hoa_svg_ServiceRequst_SelfQualif_Repair_svg__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_CertificateOfCompliance_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2040);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_CertificateOfCompliance_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_hoa_svg_ServiceRequst_SelfQualif_CertificateOfCompliance_svg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_ElectricalDiagram_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81968);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_ElectricalDiagram_svg__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_hoa_svg_ServiceRequst_SelfQualif_ElectricalDiagram_svg__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_Other_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44134);
/* harmony import */ var _hoa_svg_ServiceRequst_SelfQualif_Other_svg__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_hoa_svg_ServiceRequst_SelfQualif_Other_svg__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _domain_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32279);
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(475);









var typeOfInterventionStep = {
    type: _domain_types__WEBPACK_IMPORTED_MODULE_6__/* .ServiceRequestStepType.DETAILS */ .ln.DETAILS,
    inSummary: true,
    title: "quote:typeofIntervention.title",
    additionalCopy: "quote:additionalCopy.description.title",
    segmentEvent: "Additional Info Filled in",
    fields: [
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_6__/* .ServiceRequestFieldType.TILES */ .lZ.TILES,
            summaryTitle: "quote:description.summaryTitle",
            props: {
                name: "intervention_type",
                options: [
                    {
                        label: "quote:typeofIntervention.new_installation",
                        value: "new_installation",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((_hoa_svg_ServiceRequst_SelfQualif_ElectricalInstallation_svg__WEBPACK_IMPORTED_MODULE_1___default()), {}),
                        flow: "RFQ"
                    },
                    {
                        label: "quote:typeofIntervention.compliance",
                        value: "compliance",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((_hoa_svg_ServiceRequst_SelfQualif_Compliance_svg__WEBPACK_IMPORTED_MODULE_0___default()), {}),
                        flow: "RFQ"
                    },
                    {
                        label: "quote:typeofIntervention.electrical_diagram",
                        value: "electrical_diagram",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((_hoa_svg_ServiceRequst_SelfQualif_ElectricalDiagram_svg__WEBPACK_IMPORTED_MODULE_4___default()), {}),
                        flow: "IR",
                        price: "379€"
                    },
                    {
                        label: "quote:typeofIntervention.electrical_diagram_and_compliance_certificate",
                        value: "electrical_diagram_and_compliance_certificate",
                        treeId: "609",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((_hoa_svg_ServiceRequst_SelfQualif_ElectricalDiagram_svg__WEBPACK_IMPORTED_MODULE_4___default()), {}),
                        flow: "IR",
                        price: "499€"
                    },
                    {
                        label: "quote:typeofIntervention.certificate_of_compliance",
                        value: "certificate_of_compliance",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((_hoa_svg_ServiceRequst_SelfQualif_CertificateOfCompliance_svg__WEBPACK_IMPORTED_MODULE_3___default()), {}),
                        flow: "IR",
                        price: "179€"
                    },
                    {
                        label: "quote:typeofIntervention.certificate_of_compliance_peb",
                        value: "certificate_of_compliance_peb",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((_hoa_svg_ServiceRequst_SelfQualif_CertificateOfCompliance_svg__WEBPACK_IMPORTED_MODULE_3___default()), {}),
                        flow: "IR",
                        price: "".concat((0,i18next__WEBPACK_IMPORTED_MODULE_7__.t)("quote:electricians.steps.priceByLocale.certificateOfCompliancePEB"))
                    },
                    {
                        label: "quote:typeofIntervention.repair",
                        value: "repair",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((_hoa_svg_ServiceRequst_SelfQualif_Repair_svg__WEBPACK_IMPORTED_MODULE_2___default()), {}),
                        flow: "IR",
                        price: "99€"
                    },
                    {
                        label: "quote:typeofIntervention.other",
                        value: "other",
                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((_hoa_svg_ServiceRequst_SelfQualif_Other_svg__WEBPACK_IMPORTED_MODULE_5___default()), {}),
                        flow: "RFQ"
                    }, 
                ],
                placeholder: "quote:description.placeholder",
                validation: [
                    "isRequired"
                ]
            }
        }, 
    ]
};


/***/ }),

/***/ 53449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "uploadStep": function() { return /* binding */ uploadStep; }
/* harmony export */ });
/* harmony import */ var _domain_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32279);

var uploadStep = {
    type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestStepType.DETAILS */ .ln.DETAILS,
    inSummary: false,
    title: "quote:files.title",
    additionalCopy: "quote:additionalCopy.files.title",
    segmentEvent: "Photo Uploaded",
    fields: [
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.UPLOAD */ .lZ.UPLOAD,
            summaryTitle: "file",
            props: {
                name: "file",
                placeholder: "quote:files.placeholder"
            }
        }, 
    ]
};


/***/ }),

/***/ 85688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zipStep": function() { return /* binding */ zipStep; }
/* harmony export */ });
/* harmony import */ var _domain_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32279);

var zipStep = {
    type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestStepType.DETAILS */ .ln.DETAILS,
    inSummary: true,
    title: "quote:location.title",
    additionalCopy: "quote:additionalCopy.location.title",
    segmentEvent: "Postcode Filled in",
    fields: [
        {
            type: _domain_types__WEBPACK_IMPORTED_MODULE_0__/* .ServiceRequestFieldType.NUMBER */ .lZ.NUMBER,
            summaryTitle: "quote:location.summaryTitle",
            props: {
                name: "zip",
                placeholder: "form:placeholder.postCode",
                inputProps: {
                    maxLength: 5
                },
                validation: [
                    "isRequired",
                    "isPostalCode"
                ]
            }
        }, 
    ]
};


/***/ }),

/***/ 2040:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(2784);

function CertificateOfCompliance (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"e17a1f1f-04d1-40f7-a109-a408e214a136","data-name":"Interface-Essential Multimedia-Controls button-play-1"},React.createElement("g",{"id":"f9066b99-eeda-49f0-9922-63ec704355ab","data-name":"Group 558"},React.createElement("g",{"id":"ac702726-4d75-4339-a167-626a683c8cca","data-name":"button-play-1"},[React.createElement("path",{"id":"b2647118-abc6-4dc1-b854-4b337ed7cc1a","data-name":"Oval 279","d":"M22,14.5a8,8,0,0,0-8-8h0a8,8,0,0,0,0,16","style":{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.20000004768372px"},"key":0}),React.createElement("path",{"id":"b5a4771c-799f-4985-b489-59cae35be8a6","data-name":"Shape 102","d":"M15.15,9.5l-4.38,5.1a.26.26,0,0,0,0,.29.27.27,0,0,0,.25.17h1.94V19.5l4.38-5.1a.26.26,0,0,0,0-.29.27.27,0,0,0-.25-.17H15.15Z","style":{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2000000476837158px"},"key":1}),React.createElement("path",{"id":"a85a108b-7426-4ca1-a565-5fb7c949afe8","data-name":"Shape 326","d":"M22,23.5a.25.25,0,0,0,0,.5.25.25,0,0,0,0-.5","style":{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round"},"key":2}),React.createElement("path",{"id":"ff40f9b0-cb7e-4fb8-b1c0-487262a9ac0e","data-name":"Shape 327","d":"M22,22V20","style":{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round"},"key":3}),React.createElement("path",{"id":"a7b36653-decc-44cb-979f-206c91434837","data-name":"Shape 328","d":"M25.84,23.79a1.21,1.21,0,0,1-.05,1.15,1.19,1.19,0,0,1-1,.56H19.15a1.19,1.19,0,0,1-1-.56,1.21,1.21,0,0,1-.05-1.15l2.82-5.64a1.18,1.18,0,0,1,2.11,0Z","style":{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2000000476837158px"},"key":4})]))));
}

CertificateOfCompliance.defaultProps = {"id":"b362e9b6-103a-4f48-b196-2ddb1a94dade","data-name":"Layer 1","viewBox":"0 0 32 32"};

module.exports = CertificateOfCompliance;

CertificateOfCompliance.default = CertificateOfCompliance;


/***/ }),

/***/ 3558:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(2784);

function Check (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"hsl(0, 0%, 65%)","d":"M32,64c8.547,0,16.583-3.329,22.626-9.373C60.671,48.583,64,40.547,64,32s-3.329-16.583-9.373-22.626   C48.583,3.329,40.547,0,32,0S15.417,3.329,9.374,9.373C3.329,15.417,0,23.453,0,32s3.329,16.583,9.373,22.626   C15.417,60.671,23.453,64,32,64z M12.202,12.202C17.49,6.913,24.521,4,32,4s14.51,2.913,19.798,8.202C57.087,17.49,60,24.521,60,32   s-2.913,14.51-8.202,19.798C46.51,57.087,39.479,60,32,60s-14.51-2.913-19.798-8.202C6.913,46.51,4,39.479,4,32   S6.913,17.49,12.202,12.202z","key":0}),React.createElement("path",{"fill":"hsl(0, 0%, 65%)","d":"M23.937,48c0.021,0,0.042,0,0.063,0c0.543,0,1.064-0.221,1.442-0.614l25-26c0.765-0.796,0.741-2.062-0.056-2.828   c-0.797-0.766-2.062-0.74-2.828,0.056L24.095,43.016l-9.568-11.308c-0.714-0.844-1.976-0.949-2.819-0.235   c-0.843,0.713-0.948,1.976-0.235,2.819l11,13C22.839,47.725,23.371,48,23.937,48z","key":1})]));
}

Check.defaultProps = {"version":"1.1","id":"Ebene_1","x":"0px","y":"0px","width":"64px","height":"64px","viewBox":"0 0 64 64","enableBackground":"new 0 0 64 64","xmlSpace":"preserve"};

module.exports = Check;

Check.default = Check;


/***/ }),

/***/ 48255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(2784);

function Compliance (props) {
    return React.createElement("svg",props,[React.createElement("path",{"data-name":"Shape 512","d":"M12.45 23.68H7.68a1.19 1.19 0 01-1.19-1.19V7a1.19 1.19 0 011.19-1.21h8.46a1.16 1.16 0 01.84.35l4.67 4.67a1.19 1.19 0 01.35.84v.1","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2","key":0}),React.createElement("path",{"data-name":"Shape 513","d":"M16 5.79v4.77a1.19 1.19 0 001.2 1.19H22","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2","key":1}),React.createElement("path",{"data-name":"Shape 514","d":"M12.39 12.83l-1.7 2.26a.58.58 0 01-.43.24.6.6 0 01-.46-.17l-.92-.92","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2","key":2}),React.createElement("path",{"data-name":"Shape 515","d":"M12.39 18.2l-1.7 2.26a.58.58 0 01-.43.24.6.6 0 01-.46-.17l-.92-.92","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2","key":3}),React.createElement("path",{"data-name":"Oval 57","d":"M19.81 26.79A4.78 4.78 0 1015 22a4.78 4.78 0 004.81 4.79z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2","key":4}),React.createElement("path",{"data-name":"Shape 471","d":"M21.94 20.63l-2.31 3.08a.58.58 0 01-.44.23.57.57 0 01-.46-.17l-1.19-1.19","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2","key":5})]);
}

Compliance.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 32 32"};

module.exports = Compliance;

Compliance.default = Compliance;


/***/ }),

/***/ 81968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(2784);

function ElectricalDiagram (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Computers-Devices-Electronics / Cables / thunderbolt-cable"},React.createElement("g",{"data-name":"Group 201"},React.createElement("g",{"data-name":"thunderbolt-cable","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2"},[React.createElement("path",{"data-name":"Rectangle-path 91","d":"M20.67 23.33h4V26h-4z","key":0}),React.createElement("path",{"data-name":"Shape 1044","d":"M26 23.34h-6.67v-5.27a1.33 1.33 0 011.34-1.33h4A1.33 1.33 0 0126 18.07z","key":1}),React.createElement("path",{"data-name":"Rectangle-path 92","d":"M7.33 6h4v2.67h-4z","key":2}),React.createElement("path",{"data-name":"Shape 1045","d":"M12.67 8.67H6v5.4a1.34 1.34 0 001.33 1.33h4a1.34 1.34 0 001.34-1.33z","key":3}),React.createElement("path",{"data-name":"Shape 1046","d":"M22.67 16.73v-7.4a3.34 3.34 0 00-6.67 0v13.34a3.34 3.34 0 01-6.67 0V15.4","key":4})]))));
}

ElectricalDiagram.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 32 32"};

module.exports = ElectricalDiagram;

ElectricalDiagram.default = ElectricalDiagram;


/***/ }),

/***/ 87432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(2784);

function ElectricalInstallation (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Computers-Devices-Electronics / Power-Supply / wall-socket"},React.createElement("g",{"data-name":"Group 198"},React.createElement("g",{"data-name":"wall-socket"},[React.createElement("path",{"data-name":"Rectangle-path 89","d":"M7 9.4A2.39 2.39 0 019.4 7h13.2A2.39 2.39 0 0125 9.4v13.2a2.39 2.39 0 01-2.4 2.4H9.4A2.39 2.39 0 017 22.6z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2","key":0}),React.createElement("path",{"data-name":"Oval 72","d":"M16 22.6A6.6 6.6 0 109.4 16a6.59 6.59 0 006.6 6.6z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2","key":1}),React.createElement("path",{"d":"M13.3 15.4a.6.6 0 11-.6.6.6.6 0 01.6-.6m0-1.2a1.8 1.8 0 101.8 1.8 1.81 1.81 0 00-1.8-1.8zM18.7 15.4a.6.6 0 11-.6.6.6.6 0 01.6-.6m0-1.2a1.8 1.8 0 101.8 1.8 1.81 1.81 0 00-1.8-1.8z","fill":"#000","key":2})]))));
}

ElectricalInstallation.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 32 32"};

module.exports = ElectricalInstallation;

ElectricalInstallation.default = ElectricalInstallation;


/***/ }),

/***/ 44134:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(2784);

function Other (props) {
    return React.createElement("svg",props,[React.createElement("path",{"data-name":"Oval 144","d":"M16 24a8 8 0 10-8-8 8 8 0 008 8z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2","key":0}),React.createElement("path",{"data-name":"Shape 1054","d":"M16 12v8","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2","key":1}),React.createElement("path",{"data-name":"Shape 1055","d":"M12 16h8","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2","key":2})]);
}

Other.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 32 32"};

module.exports = Other;

Other.default = Other;


/***/ }),

/***/ 64698:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(2784);

function Repair (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"e17a1f1f-04d1-40f7-a109-a408e214a136","data-name":"Interface-Essential Multimedia-Controls button-play-1"},React.createElement("g",{"id":"f9066b99-eeda-49f0-9922-63ec704355ab","data-name":"Group 558"},React.createElement("g",{"id":"ac702726-4d75-4339-a167-626a683c8cca","data-name":"button-play-1"},[React.createElement("path",{"id":"b2647118-abc6-4dc1-b854-4b337ed7cc1a","data-name":"Oval 279","d":"M22,14.5a8,8,0,0,0-8-8h0a8,8,0,0,0,0,16","style":{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.20000004768372px"},"key":0}),React.createElement("path",{"id":"b5a4771c-799f-4985-b489-59cae35be8a6","data-name":"Shape 102","d":"M15.15,9.5l-4.38,5.1a.26.26,0,0,0,0,.29.27.27,0,0,0,.25.17h1.94V19.5l4.38-5.1a.26.26,0,0,0,0-.29.27.27,0,0,0-.25-.17H15.15Z","style":{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2000000476837158px"},"key":1}),React.createElement("path",{"id":"a85a108b-7426-4ca1-a565-5fb7c949afe8","data-name":"Shape 326","d":"M22,23.5a.25.25,0,0,0,0,.5.25.25,0,0,0,0-.5","style":{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round"},"key":2}),React.createElement("path",{"id":"ff40f9b0-cb7e-4fb8-b1c0-487262a9ac0e","data-name":"Shape 327","d":"M22,22V20","style":{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round"},"key":3}),React.createElement("path",{"id":"a7b36653-decc-44cb-979f-206c91434837","data-name":"Shape 328","d":"M25.84,23.79a1.21,1.21,0,0,1-.05,1.15,1.19,1.19,0,0,1-1,.56H19.15a1.19,1.19,0,0,1-1-.56,1.21,1.21,0,0,1-.05-1.15l2.82-5.64a1.18,1.18,0,0,1,2.11,0Z","style":{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2000000476837158px"},"key":4})]))));
}

Repair.defaultProps = {"id":"b362e9b6-103a-4f48-b196-2ddb1a94dade","data-name":"Layer 1","viewBox":"0 0 32 32"};

module.exports = Repair;

Repair.default = Repair;


/***/ }),

/***/ 29013:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(2784);

function Star (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"fill":"hsl(0, 0%, 65%)","d":"M471.563,173.778l-145.5-20.8l-64.4-132c-8-15.4-30-12.2-35.3,0l-64.4,132l-145.6,20.8c-16.4,1-21.6,20.9-10.4,33.2   l105,102.9l-25,144.5c-2.9,17.8,16.7,27.8,28.1,20.8l129.9-68.6l129.9,67.6c13.6,7,29.8-2.8,28.1-19.7l-25-144.6l105-102.9   C494.663,193.478,485.563,175.478,471.563,173.778z M342.663,288.078c-4.2,5.2-6.2,11.4-5.2,17.7l19.7,116.4l-103.9-55.1   c-6.7-2.8-13-2.8-18.7,0l-103.9,55.1l19.7-116.4c1-7.3-1-13.5-5.2-17.7l-84.1-82.1l116.4-16.6c6.2-1,11.4-4.2,14.6-10.4l52-105   l52,105c3.1,5.2,8.3,9.4,14.6,10.4l116.2,16.6L342.663,288.078z"})),React.createElement("g",{"key":1}),React.createElement("g",{"key":2}),React.createElement("g",{"key":3}),React.createElement("g",{"key":4}),React.createElement("g",{"key":5}),React.createElement("g",{"key":6}),React.createElement("g",{"key":7}),React.createElement("g",{"key":8}),React.createElement("g",{"key":9}),React.createElement("g",{"key":10}),React.createElement("g",{"key":11}),React.createElement("g",{"key":12}),React.createElement("g",{"key":13}),React.createElement("g",{"key":14}),React.createElement("g",{"key":15})]);
}

Star.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 488.022 488.022","style":{"enableBackground":"new 0 0 488.022 488.022"},"xmlSpace":"preserve"};

module.exports = Star;

Star.default = Star;


/***/ })

}]);